const Constant = {
  defaultPageSize: 50
}

export default Constant
